<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="guiService.goTo('main/diary')">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
<div class="container" *ngIf="groupedThropies">
  <h2>{{ "DIARY.THROPIES" | translate }}</h2>

  <div class="total-thropies">
    <div class="number-thropies">
      <img src="../../../../assets/img/trophy_pink.svg" alt="">
    </div>
    <p><span>{{ getCompletedThropiesNumber() }}</span> {{ "DIARY.TOTAL-THROPIES" | translate }}</p>
  </div>
  <div class="thropies-container">
    <div *ngFor="let category of groupedThropies">
      <h3>{{ "DIARY.TROPHIE_CATEGORIES."+ category.key | translate }}</h3>

      <div class="thropy" *ngFor="let thropy of category.value" (click)="openModalTrophyDetail(thropy)">
        <img src="../../../../assets/img/trophy.svg" alt="" *ngIf="thropy.unlocked">
        <img src="../../../../assets/img/trophy_locked.svg" alt="" *ngIf="!thropy.unlocked">
        <p>{{ thropy.i18nTitle[translate.currentLang.toUpperCase()] }}</p>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="!thropies">
  <h2>{{"DIARY.THROPIES" | translate}}</h2>
  <div class="total-thropies">
    <div class="number-thropies">
      <img src="../../../../assets/img/trophy_pink.svg" alt="">
    </div>
    <p>
      <span>
        <div class="skeleton" style="width: 20px; margin-left: 5px;"></div>
      </span>
      {{"DIARY.TOTAL-THROPIES" | translate}}
    </p>
  </div>
  <div class="thropies-container">
    <div class="thropy" *ngFor="let thropy of thropiesPlaceholder">
      <img src="../../../../assets/img/trophy_locked.svg" alt="">
      <div class="skeleton" style="width: 80px; margin-top: 10px;"></div>
    </div>
  </div>
</div>
